import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ContactlessReaderOutputFormat } from 'redux/configuration/configuration.types';

interface Props {
  contactlessReaderOuputFormat: ContactlessReaderOutputFormat;
  setContactlessReaderOutputFormat: (
    value: ContactlessReaderOutputFormat,
  ) => unknown;
}

const SettingsForm: React.FunctionComponent<Props> = ({
  setContactlessReaderOutputFormat,
  contactlessReaderOuputFormat,
}) => (
  <label>
    <p>
      <FormattedMessage id="config.contactlessReaderOutputFormat" />
    </p>
    <select
      onChange={(event): unknown =>
        setContactlessReaderOutputFormat(
          event.target.value as ContactlessReaderOutputFormat,
        )
      }
      value={contactlessReaderOuputFormat}
    >
      {Object.values(ContactlessReaderOutputFormat).map(value => (
        <option value={value} key={value}>
          {value}
        </option>
      ))}
    </select>
  </label>
);

export default SettingsForm;
